import { css, type Theme } from '@emotion/react';

import { removeButtonAppearance } from '../../../utils/style';
import { LINK_BUTTON_VARIANTS } from './constants';

export const button = (theme: Theme) => css`
  ${removeButtonAppearance};

  display: flex;
  align-items: center;
  gap: 20px;
  text-decoration: underline;

  &.${LINK_BUTTON_VARIANTS.PRIMARY} {
    color: ${theme.colors.primary[500]};
  }

  &.${LINK_BUTTON_VARIANTS.NEUTRAL} {
    color: ${theme.colors.gray[500]};
  }

  &:disabled {
    color: ${theme.colors.gray[300]};
    cursor: not-allowed;
    text-decoration: none;
  }
`;
